import * as d3 from 'd3'

/**
 * Class which represent a D3Map model
 */
export class D3Map {
  constructor(width, height) {
    this.width = width
    this.height = height
    this.wrapperBorder = 0
    this.base = null
    this.paddingLeftRight = 10
    this.paddingTopBottom = 3
    this.dataset = null
  }

  /**
   * Create map's canvas with the selected container
   * @param {*} selection
   */
  canvas(selection) {
    this.base = selection

    var svgWidth = this.width + this.wrapperBorder * 2
    var svgHeight = this.height + this.wrapperBorder * 2
    var svg = selection
      .append('svg')
      .attr('class', 'svg canvas')
      .attr('width', '100%')
      .attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
      .attr('preserveAspectRatio', 'xMaxYMin')
      .attr('shape-rendering', 'auto')

    var svgDefs = svg.append('defs')
    svgDefs
      .append('clipPath')
      .attr('id', 'wrapperClipPath')
      .attr('class', 'wrapper clipPath')
      .append('rect')
      .attr('class', 'background-map')
      .attr('width', this.width)
      .attr('height', this.height)

    var filter = svgDefs
      .append('svg:filter')
      .attr('id', 'minimapDropShadow_qwpyza')
      .attr('x', '-20%')
      .attr('y', '-20%')
      .attr('width', '150%')
      .attr('height', '150%')
    filter
      .append('svg:feOffset')
      .attr('result', 'offOut')
      .attr('in', 'SourceGraphic')
      .attr('dx', '1')
      .attr('dy', '1')
    filter
      .append('svg:feColorMatrix')
      .attr('result', 'matrixOut')
      .attr('in', 'offOut')
      .attr('type', 'matrix')
      .attr('values', '0.1 0 0 0 0 0 0.1 0 0 0 0 0 0.1 0 0 0 0 0 0.5 0')
    filter
      .append('svg:feGaussianBlur')
      .attr('result', 'blurOut')
      .attr('in', 'matrixOut')
      .attr('stdDeviation', '10')
    filter
      .append('svg:feBlend')
      .attr('in', 'SourceGraphic')
      .attr('in2', 'blurOut')
      .attr('mode', 'normal')

    var outerWrapper = svg
      .append('g')
      .attr('class', 'wrapper outer')
      .attr('transform', 'translate(0, 0)')
    outerWrapper
      .append('rect')
      .attr('class', 'background-map')
      .attr('width', this.width + this.wrapperBorder * 2)
      .attr('height', this.height + this.wrapperBorder * 2)

    var innerWrapper = outerWrapper
      .append('g')
      .attr('class', 'wrapper inner')
      .attr('clip-path', 'url(#wrapperClipPath)')
      .attr('transform', 'translate(' + this.wrapperBorder + ',' + this.wrapperBorder + ')')

    innerWrapper
      .append('rect')
      .attr('class', 'background-map')
      .attr('width', this.width)
      .attr('height', this.height)

    var panCanvas = innerWrapper
      .append('g')
      .attr('class', 'panCanvas')
      .attr('width', this.width)
      .attr('height', this.height)
      .attr('transform', 'translate(0,0)')

    panCanvas
      .append('rect')
      .attr('class', 'background-map')
      .attr('width', this.width)
      .attr('height', this.height)

    var zoom = d3.zoom().scaleExtent([1, 10])

    let that = this

    //let el = d3.select(".panCanvas svg");

    // updates the zoom boundaries based on the current size and scale
    var updateCanvasZoomExtents = function() {
      var scale = innerWrapper.property('__zoom').k
      var targetWidth = svgWidth
      var targetHeight = svgHeight
      var viewportWidth = that.width
      var viewportHeight = that.height

      /*let xA = -viewportWidth / scale < -that.itemWidth ? -that.itemWidth : -viewportWidth / scale;
      let yA = -viewportHeight / scale < -that.itemHeight ? -that.itemHeight : -viewportHeight / scale;

      let xB = (viewportWidth / scale + targetWidth) > that.itemWidth ? that.itemWidth : (viewportWidth / scale + targetWidth)
      let yB =  (viewportHeight / scale + targetHeight) > that.itemHeight ? that.itemHeight : (viewportWidth / scale + targetHeight)

      let pointA = [xA, yA]
      let pointB = [xB, yB]

      zoom.translateExtent([
        pointA, pointB
      ])*/
      zoom.translateExtent([
        [-viewportWidth / scale, -viewportHeight / scale],
        [viewportWidth / scale + targetWidth, viewportHeight / scale + targetHeight],
      ])
    }

    var zoomHandler = function() {
      panCanvas.attr('transform', d3.event.transform)

      svg
        .selectAll('.area-infos text')
        .attr('font-size', d3.event.transform.k > 2 ? '14px' : '16px')

      updateCanvasZoomExtents()
    }

    zoom.on('zoom', zoomHandler)

    innerWrapper.call(zoom)

    if (Number(this.dataset.site_location) === 'deutschland.moritzburg.schlossmoritzburg') {
      const scale = 8
      const zoomWidth = (this.width * (1.5 - scale)) / 2
      const zoomHeight = (this.height * -scale) / 2
      innerWrapper.call(
        zoom.transform,
        d3.zoomIdentity.translate(zoomWidth, zoomHeight).scale(scale),
      )
    }

    /** ADD SHAPE **/
    this.canvas.addItem = function(item) {
      item.attr('id', 'mapCanvas')
      panCanvas.node().appendChild(item.node())
      that.itemWidth = item.node().getBBox().width
      that.itemHeight = item.node().getBBox().height
    }

    /** RENDER **/
    this.canvas.render = function() {
      svgDefs
        .select('.clipPath .background')
        .attr('width', this.width)
        .attr('height', this.height)

      svg
        .attr('width', this.width + this.wrapperBorder * 2)
        .attr('height', this.height + this.wrapperBorder * 2)

      outerWrapper
        .select('.background-map')
        .attr('width', this.width + this.wrapperBorder * 2)
        .attr('height', this.height + this.wrapperBorder * 2)

      innerWrapper
        .attr('transform', 'translate(' + this.wrapperBorder + ',' + this.wrapperBorder + ')')
        .select('.background-map')
        .attr('width', this.width)
        .attr('height', this.height)

      panCanvas
        .attr('width', this.width)
        .attr('height', this.height)
        .select('.background-map')
        .attr('width', this.width)
        .attr('height', this.height)
    }

    this.canvas.reset = function() {
      //svg.call(zoom.event);
      //svg.transition().duration(750).call(zoom.event);
      zoom.transform(panCanvas, d3.zoomIdentity)
      svg.property('__zoom', d3.zoomIdentity)
    }

    this.canvas.update = function() {
      zoom.transform(panCanvas)
      // update the '__zoom' property with the new transform on the rootGroup which is where the zoomBehavior stores it since it was the
      // call target during initialization
      //innerWrapper.property("__zoom", minimapZoomTransform);

      updateCanvasZoomExtents()
    }

    updateCanvasZoomExtents()

    this.canvas.width = function(value) {
      if (!arguments.length) return this.width
      this.width = parseInt(value, 10)
      return this
    }

    this.canvas.height = function(value) {
      if (!arguments.length) return this.height
      this.height = parseInt(value, 10)
      return this
    }

    return this.canvas
  }

  /**
   * Set retrieved dataset
   * @param {*} value
   */
  setDataset(value) {
    this.dataset = value
  }

  /**
   * Set width of the map
   * @param {*} value
   */
  setWidth(value) {
    this.width = value
  }

  /**
   * Set height of the map
   * @param {*} value
   */
  setHeight(value) {
    this.height = value
  }

  /**
   * Load the map SVG
   * @param {*} svgPath
   */
  loadSVG(svgPath) {
    let that = this
    return new Promise((resolve, reject) => {
      d3.xml(svgPath)
        .then(data => {
          setTimeout(() => {
            d3.selectAll('#mapCanvas').remove()
            that.canvas.addItem(d3.select(data.documentElement))
            resolve(true)
          })
        })
        .catch(error => {
          console.error('Error when loading SVG:', error.message)
          reject(error)
        })
    })
  }
}
